import React, { useRef, useState } from "react";
import { Formik } from "formik";
import moment from "moment";
import { RiWhatsappLine } from "react-icons/ri";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import * as utils from "../../../_metronic/utils/utils";
import styles from "../../../styles/Login.module.css";
import Step1 from "../../components/reativar-acesso/Step1";
import Step2 from "../../components/reativar-acesso/Step2";
import { useAlert } from "../../context/AlertContext";
import { reativarAcesso, login } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
import * as config from "../../store/ducks/config.duck";
import { createFormikValidation, validaCnpj, validaCpf } from "../../utils/Utils";
import { Constants } from "../../utils/Constants";

const ReativarAcesso = (props) => {
    const data = props.location?.state;

    if (!data?.id) props.history.push("/");

    const { showAlert } = useAlert();

    const history = useHistory();

    const [step, setStep] = useState(1);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [planoSelecionado, setPlanoSelecionado] = useState(null);

    const formRef = useRef(null);

    const getInitialValues = () => {
        return {
            nome_titular_cartao: "",
            documento_titular_cartao: "",
            numero_cartao: "",
            data_vencimento_cartao: "",
            cvv: "",
            cep: "",
            logradouro: "",
            numero: "",
            bairro: "",
            cidade: "",
            estado: "",
        };
    };

    const validate = (values) => {
        const map = new Map();
        const errors = {};

        if (step === 2) {
            map.set("nome_titular_cartao", "nome do titular");
            map.set("documento_titular_cartao", "CPF/CNPJ do titular");
            map.set("numero_cartao", "número do cartão");
            map.set("data_vencimento_cartao", "data de vencimento do cartão");
            map.set("cvv", "CVV");
            map.set("cep", "CEP");
            map.set("logradouro", "logradouro");
            map.set("numero", "número");
            map.set("bairro", "bairro");
            map.set("cidade", "cidade");
            map.set("estado", "estado");

            if (values.nome_titular_cartao.split(" ").length < 2) {
                errors.nome_titular_cartao = "Por favor, insira o nome completo do titular do cartão.";
            }

            if ((values.documento_titular_cartao.length < 15 && !validaCpf(values.documento_titular_cartao)) || (values.documento_titular_cartao.length > 14 && !validaCnpj(values.documento_titular_cartao))) {
                errors.documento_titular_cartao = "O CPF/CNPJ do titular está incorreto";
            }

            if (/^(34|37)/.test(values.numero_cartao.replace(/[\s_]/g, ""))) {
                // amex
                if (values.numero_cartao?.replace(/\D/g, "").length != 15) {
                    errors.numero_cartao = "O número do cartão está incorreto";
                }
                if (values.cvv?.replace(/\D/g, "").length != 4) {
                    errors.cvv = "O CVV está incorreto";
                }
            } else {
                if (values.numero_cartao?.replace(/\D/g, "").length != 16) {
                    errors.numero_cartao = "O número do cartão está incorreto";
                }
                if (values.cvv?.replace(/\D/g, "").length != 3) {
                    errors.cvv = "O CVV está incorreto";
                }
            }

            if (!moment(values.data_vencimento_cartao, "MM/YY").isValid() || moment(values.data_vencimento_cartao, "MM/YY").isBefore(moment())) {
                errors.data_vencimento_cartao = "A data de validade do cartão é inválida.";
            }
        }

        return { ...errors, ...createFormikValidation(map, values) };
    };

    const onSubmit = async (values) => {
        if (step === 1) {
            setStep(2);
        } else {
            setIsSubmitting(true);

            reativarAcesso(formatarAntesEnvio(values))
                .then(() => {
                    setStep((ant) => ant + 1);

                    window.scrollTo(0, 0);
                })
                .catch((err) => {
                    showAlert({
                        icon: "error",
                        title: "Ops!",
                        text: Array.isArray(err?.response?.data?.errors) ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.",
                        textStyle: { textAlign: "center" },
                        confirmButton: true,
                        confirmText: "Ok",
                    });
                })
                .finally(() => setIsSubmitting(false));
        }
    };

    const formatarAntesEnvio = (values) => {
        return {
            ...values,
            plano: planoSelecionado?.value ?? "",
            data_vencimento_cartao: values.data_vencimento_cartao ? `20${values.data_vencimento_cartao.substring(3, 5)}-${values.data_vencimento_cartao.substring(0, 2)}-01` : "",
            id: data.id,
        };
    };

    const returnButton = () => {
        if (step === 1) {
            props.history.push("/");
        } else {
            setStep((ant) => ant - 1);
        }
    };

    const textoReturnButton = () => {
        const obj = {
            1: "Reative seu acesso",
            2: "Dados de pagamento",
        };

        return obj[step];
    };

    const textoSubtitulo = () => {
        const obj = {
            1: "Contrate um novo plano para voltar a utilizar todas as funcionalidades do sistema.",
            2: "Informe abaixo seus dados de pagamento.",
        };

        return obj[step];
    };

    const entrar = async () => {
        setIsSubmitting(true);

        login(data)
            .then((res) => {
                if (res.data.primeiro_acesso) {
                    props.history.push(`/primeiro-acesso?usuario=${data.usuario}`);

                    return;
                }
                utils.setStorage("authToken", res.data.token, null);
                props.login(res.data);
                history.push("/");
            })
            .catch((err) => {
                showAlert({
                    icon: "error",
                    title: "Ops!",
                    text: Array.isArray(err?.response?.data?.errors) ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.",
                    textStyle: { textAlign: "center" },
                    confirmButton: true,
                    confirmText: "Ok",
                });
            })
            .finally(() => setIsSubmitting(false));
    };

    if (step === 3) {
        return (
            <div className={styles.authContainer}>
                <div className={styles.loginContainer}>
                    <div className={styles.loginLeft}>
                        <img src={"/images/logo.png"} alt="Suria Logo" className={styles.logoImg} />

                        <div className={styles.boxPagamentoConfirmado}>
                            <img className={styles.checkIcon} src={"/images/check-icon.png"} alt="Pagamento Confirmado" />

                            <div>
                                <p className={styles.textoConfirmado}>Pagamento confirmado!</p>

                                <p className={styles.textoConfirmadoExtra}>Agora você já pode registrar suas transações e acessar o Painel SUR.IA para controlar suas finanças de forma inteligente.</p>
                            </div>

                            <div className={styles.boxBotoesConfirmado}>
                                <button type="button" className={styles.buttonVoltarLogin} onClick={entrar} disabled={isSubmitting}>
                                    {!isSubmitting ? "Ir para o Painel do Cliente" : <div className="icon-loading" style={{ color: "#0d9f0a" }} />}
                                </button>

                                <button className={styles.buttonConversar} onClick={() => window.open(`https://wa.me/${Constants.numeroWhatsapp}`, "_blank")}>
                                    Conversar com minha Assistente SUR.IA
                                    <RiWhatsappLine size={20} color="#FFFFFF" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className={styles.loginRight}>
                        <div className={styles.imagemLateralLogin} style={{ backgroundImage: "url(/images/lateral-login.png)" }} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.authContainer}>
            <div className={styles.loginContainer}>
                <div className={styles.loginLeft}>
                    <img src={"/images/logo.png"} alt="Suria Logo" className={styles.logoImg} />

                    <div className={step === 3 ? styles.containerFormPlano : styles.containerFormCadastro}>
                        <button type="button" className={styles.buttonBack} onClick={returnButton}>
                            <ArrowBackIosIcon />

                            <p>{textoReturnButton()}</p>
                        </button>

                        <p className={styles.textoPrimeiroAcesso}>{textoSubtitulo()}</p>

                        <Formik innerRef={formRef} initialValues={getInitialValues()} validate={validate} onSubmit={onSubmit}>
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                                <form noValidate onSubmit={handleSubmit} className={styles.formLoginContainer}>
                                    {step === 1 && <Step1 setPlanoSelecionado={setPlanoSelecionado} setStep={setStep} />}

                                    {step === 2 && <Step2 values={values} errors={errors} touched={touched} handleChange={handleChange} handleBlur={handleBlur} submitting={isSubmitting} planoSelecionado={planoSelecionado} setFieldValue={setFieldValue} />}

                                    {step === 2 && (
                                        <div className={`${styles.buttonContainer} ${styles.paddingButton}`}>
                                            <button type="submit" className={styles.buttonLogin} disabled={isSubmitting}>
                                                {!isSubmitting ? "Realizar pagamento" : <div className="icon-loading" />}
                                            </button>
                                        </div>
                                    )}
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className={styles.loginRight}>
                    <div className={styles.imagemLateralLogin} style={{ backgroundImage: "url(/images/lateral-login.png)" }} />
                </div>
            </div>
        </div>
    );
};

export default connect(null, { ...auth.actions, ...config.actions })(ReativarAcesso);
